export default "__VITE_ASSET__OEmu2Eer__"